import { Link } from "react-router-dom";

const QUICK_LINKS = [
  { to: "/", label: "首页" },
  { to: "/category/movie", label: "电影频道" },
  { to: "/category/tv", label: "电视剧频道" },
  { to: "/news", label: "影视资讯" },
  { to: "/about", label: "关于我们" },
];

const CATEGORY_LINKS = [
  { to: "/category/movie?genre=科幻", label: "科幻电影" },
  { to: "/category/movie?genre=悬疑", label: "悬疑电影" },
  { to: "/category/tv?genre=古装", label: "古装剧集" },
  { to: "/category/tv?genre=青春", label: "青春剧集" },
  { to: "/search", label: "全网搜索" },
];

const SOCIALS = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-bilibili-line", label: "哔哩哔哩" },
  { icon: "ri-youtube-fill", label: "视频号" },
];

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-background-900 to-primary-950 border-t border-background-800">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-fill text-background-50 text-xl"></i>
              </span>
              <span className="font-heading text-xl font-semibold text-foreground-50">
                西瓜<span className="text-primary-400">影音</span>
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              西瓜影音聚合高清电影、电视剧与影视资讯，为影视爱好者提供快速查找、清爽浏览与流畅观影的体验。
            </p>
            <div className="flex items-center gap-2 mt-5">
              {SOCIALS.map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  aria-label={s.label}
                  className="w-9 h-9 rounded-full bg-background-800/80 flex items-center justify-center text-foreground-300 hover:text-primary-400 hover:bg-background-700 cursor-pointer transition-colors"
                >
                  <i className={`${s.icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-100 mb-4">
              <a href="#footer-quick">快捷导航</a>
            </h4>
            <ul id="footer-quick" className="space-y-2.5">
              {QUICK_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-100 mb-4">
              <a href="#footer-cats">热门分类</a>
            </h4>
            <ul id="footer-cats" className="space-y-2.5">
              {CATEGORY_LINKS.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-100 mb-4">
              <a href="#footer-contact">联系我们</a>
            </h4>
            <ul id="footer-contact" className="space-y-2.5 text-sm text-foreground-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                 feedback@xigua-video.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-primary-400"></i>
                 support@xigua-video.com
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-primary-400 mt-0.5"></i>
                <span>北京市朝阳区影视文化产业园 A 座</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800/80 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            © {new Date().getFullYear()} 西瓜影音 · 本站为影视内容演示站点，所有影片信息为示例数据
          </p>
          <p className="text-xs text-foreground-500">
            高清 · 正版 · 聚合 —— 让每一次观看都值得
          </p>
        </div>
      </div>
    </footer>
  );
}